module.exports = __webpack_public_path__ + "static/img/02.05bed6bf.png";